import React from 'react'
import styled from 'styled-components'

import { StreamLogo } from 'components'
import { Box } from 'components/Box'
import { FooterCredit } from 'components/FooterCredit'

const Root = styled(Box).attrs({
  marginTop: 4,
  paddingY: 2,
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  z-index: 10;
  text-align: center;
`

export const Footer = () => {
  return (
    <div>
      <Root>
        <StreamLogo size={1} />
      </Root>
      <FooterCredit />
    </div>
  )
}
